import { Box, Typography } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { useEffect, useMemo } from "react";

interface PercentageChangeProps {
  value: number | undefined;
  isPositiveValueBeneficial: boolean;
}

const colors = {
  green: "#6DC4BA",
  red: "#F44336",
  gray: "#757575",
  lightGreen: "#EEF8F7",
  lightRed: "#FFEBEE",
  lightGray: "#E0E0E0",
};

const PercentageChange = ({ value, isPositiveValueBeneficial }: PercentageChangeProps) => {
  const displayValue = useMemo(() => {
    if (value === undefined || value === null) return undefined;
    return Math.abs(Number(value.toFixed(1)));
  }, [value]);

  const isPositiveValue = useMemo(() => value && Number(value.toFixed(1)) > 0, [value]);
  const isNegativeValue = useMemo(() => value && Number(value.toFixed(1)) < 0, [value]);

  const styles = useMemo(() => {
    const color = isPositiveValue
      ? isPositiveValueBeneficial
        ? colors.green
        : colors.red
      : isNegativeValue
        ? isPositiveValueBeneficial
          ? colors.red
          : colors.green
        : colors.gray;

    const backgroundColor = isPositiveValue
      ? isPositiveValueBeneficial
        ? colors.lightGreen
        : colors.lightRed
      : isNegativeValue
        ? isPositiveValueBeneficial
          ? colors.lightRed
          : colors.lightGreen
        : colors.lightGray;

    return {
      color,
      backgroundColor,
      border: `1px solid ${color}`,
    };
  }, [value, isPositiveValueBeneficial]);

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        borderRadius: 1.5,
        paddingBlock: 0.2,
        paddingInline: 0.5,
        fontWeight: "bold",
        ...styles,
      }}
    >
      <Typography sx={{ fontSize: "14px" }}>
        {displayValue === undefined ? "- - -" : `${displayValue}%`}
      </Typography>
      {isPositiveValue ? <ArrowUpwardIcon sx={{ fontSize: "14px", marginLeft: "2px" }} /> : null}
      {isNegativeValue ? <ArrowDownwardIcon sx={{ fontSize: "14px", marginLeft: "2px" }} /> : null}
    </Box>
  );
};

export default PercentageChange;
